import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'

const AdminFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer id='footer'>
        <div className="footer-bot">
          <Container> 
            <Row>
              <Col md={12}>
                <div className="copyright">© Copyright {currentYear} Blue Starling Corp. All rights reserved. Registered with FINTRAC Reg. No. M20666701</div>
              </Col>
            </Row>
          </Container>
        </div>
      </footer>
    </>
  )
}

export default AdminFooter;